import React from 'react';

const DiscountFlagImage = ({ paymentMethod, content, imgData }) => {
  if (paymentMethod.discount > 0) {
    return (
      <div className="text-method-payment">
        <label htmlFor={paymentMethod.class}>
          <div className="container-infos-payment flex">
            {content}

            <div className="discount-flag before img-provider" data-discount={paymentMethod.discount + '% de desconto'}>
              {imgData ? imgData : null}
            </div>
          </div>
        </label>
      </div>
    );
  }

  return (
    <div className="text-method-payment">
      <label htmlFor={paymentMethod.class}>
        <div className="container-infos-payment flex">
          {content}

          <div className="img-provider" style={{ paddingTop: '20px', marginLeft: '15px' }}>
            {imgData ? imgData : null}
          </div>
        </div>
      </label>
    </div>
  );
};

export default DiscountFlagImage;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/desktop/DiscountFlagImage.jsx